import { gsap } from "gsap";
import Swiper, { Autoplay, EffectFade, Lazy, Navigation, Pagination, Scrollbar, FreeMode, Thumbs } from 'swiper';
import 'swiper/swiper.scss';
import 'swiper/modules/autoplay/autoplay.scss';
import 'swiper/modules/effect-fade/effect-fade.scss';
//import 'swiper/modules/free-mode/free-mode.scss';
import 'swiper/modules/lazy/lazy.scss';
import 'swiper/modules/scrollbar/scrollbar.scss';
import 'swiper/modules/free-mode/free-mode.scss';
import 'swiper/modules/thumbs/thumbs.scss';

document.addEventListener('DOMContentLoaded', ()=> {

    const awards = document.querySelector('.js-awards'),
          cooperation = document.querySelector('.js-cooperationSwiper'),
          delivers = document.querySelector('.js-deliversSwiper'),
          hero = document.querySelector('.js-heroSwiper'),
          mobile_carousel = document.querySelectorAll('.js-mobileCarousel'),
          ref = document.querySelector('.js-refObjectsSwiper'),
          simple = document.querySelectorAll('.js-simpleSwiper'),
          social = document.querySelectorAll('.js-socialSwiper');

    let speed = 400;
    
    const awardsCarousel = () => {
        const swiper = new Swiper(awards, {
            modules: [Autoplay, Navigation, Pagination],
            autoplay: {
                delay: 4000,
            },
            centeredSlides: true,
            loop: true,
            breakpoints: {
                641: {
                    centeredSlides: false,
                    centeredSlidesBounds: true,
            	    slidesPerView: 2,
                },
                769: {
                    centeredSlides: false,
                    centeredSlidesBounds: true,
            	    slidesPerView: 3,
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            slidesPerView: 'auto',
            spaceBetween: 20,
            speed: speed
	    });
    }

    const cooperationCarousel = () => {
        const swiper = new Swiper(cooperation, {
            modules: [Navigation, Pagination, Scrollbar],
            breakpoints: {
                
                641: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                769: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
                1024: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                },
            },
            navigation: {
                nextEl: cooperation.parentNode.querySelector('.swiper-button-next'),
                prevEl: cooperation.parentNode.querySelector('.swiper-button-prev'),
            },

            slidesPerView: 2,
            slidesPerGroup: 2,
            speed: speed,
            scrollbar: {
                el: cooperation.parentNode.parentNode.querySelector('.swiper-scrollbar'),
                    hide: false,
            }
        });
    }

    const deliversCarousel = () => {
        const swiper = new Swiper(delivers, {
            modules: [Navigation, Pagination, Scrollbar],
            navigation: {
                nextEl: delivers.parentNode.querySelector('.swiper-button-next'),
                prevEl: delivers.parentNode.querySelector('.swiper-button-prev'),
            },

            slidesPerView: 1,
            slidesPerGroup: 1,
            speed: speed,
            scrollbar: {
                el: delivers.parentNode.querySelector('.swiper-scrollbar'),
                    hide: false,
            }
        });
    }

    const heroCarousel = () => {
        let started = false, chars2;

        const heroSignature = (idx) => {
            const slide = document.querySelector('.c-hero').querySelectorAll('.swiper-slide')[idx];

            if (!slide || !slide.querySelector('.c-hero__title')) return;

            const textWrapper1 = slide.querySelector('.c-hero__title .part1'),
                  textWrapper2 = slide.querySelector('.c-hero__title .part2');

            slide.querySelector('.c-hero__title').style.visibility = 'visible';
            textWrapper1.innerHTML = textWrapper1.textContent.replace(/\S/g, "<span class='char'>$&</span>");

            let chars1 = textWrapper1.querySelectorAll('.char');

            if (textWrapper2) {
                textWrapper2.innerHTML = textWrapper2.textContent.replace(/\S/g, "<span class='char'>$&</span>");
                chars2 = textWrapper2.querySelectorAll('.char');
            }

            if (slide.querySelector('.o-more')) {
                slide.querySelector('.o-more').style.display = 'block';
            }

            const tl = gsap.timeline();

            tl.fromTo(chars1, { autoAlpha: 0 }, { autoAlpha: 1, stagger: .15 }, '+=1')
              .fromTo(chars2, { autoAlpha: 0 }, { autoAlpha: 1, stagger: .15 }, '-=.1')
              .from(slide.querySelector('p'), { autoAlpha: 0, y: 20 })
              .from(slide.querySelector('.o-more'), { autoAlpha: 0, y: -20 }, '-=.5');
        };

        const setVideoSources = () => {
            const isMobile = window.matchMedia('(max-width: 768px)').matches;
            hero.querySelectorAll('.js-heroVideo').forEach(video => {
                const src = isMobile
                    ? (video.dataset.srcMobile || video.dataset.srcDesktop)
                    : (video.dataset.srcDesktop || video.dataset.srcMobile);
                if (src && video.getAttribute('src') !== src) {
                    video.setAttribute('src', src);
                }
            });
        };

        // Zabezpieczenie przed zawisnieciem na slajdzie, gdy film nigdy nie ruszy.
        // Liczy sie BRAK POSTEPU, a nie czas od startu: kazde zdarzenie 'progress'
        // (naplywajace dane) uzbraja licznik od nowa. Wersja liczaca czas od startu
        // wycinala slajd na telefonie, gdzie 4,7 MB przy preload="metadata" nie zdazy
        // dojsc do 'playing' w kilka sekund - demo bez tego licznika dziala poprawnie.
        const VIDEO_STALL_TIMEOUT = 20000;

        // Spinner to .swiper-lazy-preloader – gotowa klasa Swipera,
        // kolorowana przez --swiper-preloader-color, więc bez własnego CSS-a animacji.
        const setVideoLoading = (video, isLoading) => {
            const wrap = video.closest('.c-hero__video');
            if (wrap) wrap.classList.toggle('is-loading', isLoading);
        };

        const clearWatchdog = (video) => {
            if (video._heroWatchdog) {
                clearTimeout(video._heroWatchdog);
                video._heroWatchdog = null;
            }
        };

        // Zdejmuje handlery dopięte przy poprzedniej aktywacji slajdu.
        // Bez tego kolejne powroty na ten sam slajd kumulują listenery
        // i slideNext() odpala się tyle razy, ile razy slajd był oglądany.
        const resetVideo = (video) => {
            // Znacznik aktywacji – pozwala zignorować odrzucenie play() pochodzące
            // z poprzedniego wyświetlenia tego samego slajdu.
            video._heroToken = (video._heroToken || 0) + 1;

            if (video._heroEnded) {
                video.removeEventListener('ended', video._heroEnded);
                video._heroEnded = null;
            }
            if (video._heroWaiting) {
                video.removeEventListener('waiting', video._heroWaiting);
                video.removeEventListener('stalled', video._heroWaiting);
                video._heroWaiting = null;
            }
            if (video._heroProgress) {
                video.removeEventListener('progress', video._heroProgress);
                video.removeEventListener('loadeddata', video._heroProgress);
                video.removeEventListener('canplay', video._heroProgress);
                video._heroProgress = null;
            }
            if (video._heroPlaying) {
                video.removeEventListener('playing', video._heroPlaying);
                video._heroPlaying = null;
            }
            clearWatchdog(video);
            setVideoLoading(video, false);
        };

        const pauseAllVideos = () => {
            hero.querySelectorAll('.js-heroVideo').forEach(video => {
                resetVideo(video);

                if (!video.paused) {
                    video.pause();
                    video.currentTime = 0;
                }
            });
        };

        const handleVideoSlide = (swiperInstance) => {
            const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
            const video = activeSlide ? activeSlide.querySelector('.js-heroVideo') : null;

            // Slajd bez wideo – wznów zwykły autoplay slidera. Bez tego autoplay
            // zatrzymany na czas filmu nigdy nie wraca, gdy użytkownik przewinie ręcznie.
            if (!video) {
                if (swiperInstance.autoplay) swiperInstance.autoplay.start();
                return;
            }

            // Zatrzymaj autoplay na czas wideo
            if (swiperInstance.autoplay) swiperInstance.autoplay.stop();
            video.currentTime = 0;

            // Film dobiegł końca – przejdź od razu dalej.
            const resume = () => {
                resetVideo(video);
                swiperInstance.slideNext();
                if (swiperInstance.autoplay) swiperInstance.autoplay.start();
            };

            // Film się nie odtworzy (zablokowany autoplay na iOS, tryb niskiego zużycia
            // energii, wolne łącze). NIE pomijamy slajdu – zostaje poster i tekst,
            // a slider przesunie się normalnym autoplayem po zwykłych 9 s.
            // Wcześniej slajd znikał, przez co karuzela startowała od drugiego slajdu.
            const degradeToPoster = () => {
                resetVideo(video);
                if (!video.paused) video.pause();
                if (swiperInstance.autoplay) swiperInstance.autoplay.start();
            };

            const armWatchdog = () => {
                clearWatchdog(video);

                // W karcie w tle Chrome wstrzymuje dekodowanie: play() się spełnia,
                // ale currentTime stoi i 'playing' nie przychodzi. To nie jest zacięcie,
                // więc nie pomijamy slajdu – poczekamy, aż użytkownik wróci na kartę.
                if (document.hidden) return;

                video._heroWatchdog = setTimeout(degradeToPoster, VIDEO_STALL_TIMEOUT);
            };

            const onWaiting = () => {
                setVideoLoading(video, true);
                armWatchdog();
            };

            // Dane napływają – to nie jest zacięcie, więc licznik startuje od nowa.
            const onProgress = () => armWatchdog();

            const onPlaying = () => {
                setVideoLoading(video, false);
                clearWatchdog(video);
            };

            resetVideo(video);
            const token = video._heroToken;
            video._heroEnded = resume;
            video._heroWaiting = onWaiting;
            video._heroProgress = onProgress;
            video._heroPlaying = onPlaying;
            video.addEventListener('ended', resume);
            video.addEventListener('waiting', onWaiting);
            video.addEventListener('stalled', onWaiting);
            video.addEventListener('progress', onProgress);
            video.addEventListener('loadeddata', onProgress);
            video.addEventListener('canplay', onProgress);
            video.addEventListener('playing', onPlaying);

            // readyState < HAVE_FUTURE_DATA – film musi się jeszcze doczytać,
            // więc od razu pokazujemy spinner (na komórce to reguła, nie wyjątek).
            if (video.readyState < 3) onWaiting();

            // Odtworzenie z obsługą przeglądarek wymagających interakcji
            const playPromise = video.play();
            if (playPromise !== undefined) {
                playPromise.catch((error) => {
                    // Odrzucenie z nieaktualnej aktywacji slajdu – ignorujemy.
                    if (video._heroToken !== token) return;

                    // AbortError to skutek naszego własnego pause() przy zmianie slajdu
                    // (hook init startuje film, a slideChangeTransitionStart go pauzuje).
                    // Potraktowanie tego jako blokady autoplaya pomijało slajd wideo za każdym razem.
                    if (error && error.name === 'AbortError') return;

                    // Realna blokada autoplaya (typowo NotAllowedError na iOS) –
                    // zostaw slajd z posterem zamiast go pomijać.
                    degradeToPoster();
                });
            }
        };

        setVideoSources();

        const swiper = new Swiper(hero, {
            modules: [Autoplay, EffectFade, Lazy, Navigation],
            allowTouchMove: false,
            autoplay: {
                delay: 9000,
                disableOnInteraction: false,
            },
            lazy: 0,
            loop: 1,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: false,
            },
            speed: 400,
            on: {
                init: (swiperInstance) => {
                    heroSignature(1);
                    started = true;
                    handleVideoSlide(swiperInstance);
                },
                slideChangeTransitionStart: () => {
                    const activeSlide = hero.querySelector('.swiper-slide-active');
                    if (activeSlide && activeSlide.querySelector('.c-hero__photo')) {
                        activeSlide.querySelector('.c-hero__photo').classList.add('animated', 'play');
                    }
                    if (started) heroSignature(swiper.activeIndex);

                    pauseAllVideos();
                },
                slideChangeTransitionEnd: (swiperInstance) => {
                    const slides = hero.querySelectorAll('.swiper-slide');
                    slides.forEach(slide => {
                        if (!slide.classList.contains('swiper-slide-active')) {
                            const photo = slide.querySelector('.c-hero__photo');
                            if (photo) photo.classList.remove('animated', 'play');
                        }
                    });

                    handleVideoSlide(swiperInstance);
                },
            },
        });

        // Powrót na kartę: wznów film na aktywnym slajdzie (w tle Chrome go nie odtwarza),
        // a na slajdzie bez wideo po prostu wznów autoplay slidera.
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) handleVideoSlide(swiper);
        });
    }

    const mobileCarousel = () => {
        let mediaQuery = '(max-width: 768px)',
            mediaQueryList = window.matchMedia(mediaQuery);

        for (let i = 0; i < mobile_carousel.length; i++) {
            let swiper;

            const start = ()=> {
                swiper = new Swiper(mobile_carousel[i], {
                    autoHeight: true,
                    modules: [Pagination],
                    centeredSlides: 1,
                    loop: 1,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                    speed: 500
        	    });
            }

            mediaQueryList.addEventListener('change', event => {
                event.matches ? start() : swiper.destroy();
            })

            mediaQueryList.matches ? start() : false;
        }
    }

    const products_carousel = () => {
        const swiper_small = new Swiper(document.querySelector('.js-productSmallCarousel'), {
            modules: [Thumbs, Pagination],
    	    // slidesPerView: 3,
            speed: 500,
            //spaceBetween: 26,
            freeMode: true,
            slidesPerView: 'auto',
            // spaceBetween: 0,
            // breakpoints: {
            //     511: {
            //         slidesPerGroup: 2,
            //         slidesPerView: 2,
            //         spaceBetween: 26,
            //     },
            // },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            watchSlidesProgress: true,
	    });

        const swiper_big = new Swiper(document.querySelector('.js-productBigCarousel'), {
            modules: [Thumbs, Navigation],
            speed: 500,
            thumbs: {
                swiper: swiper_small,
            },
            navigation: {
                nextEl: document.querySelector('.js-gallery').querySelector('.swiper-button-next'),
                prevEl: document.querySelector('.js-gallery').querySelector('.swiper-button-prev'),
            },
	    });
    }

    const refCarousel = () => {
        const swiper = new Swiper(ref, {
            modules: [Navigation, Pagination],
            centeredSlides: true,
            loop: true,
            breakpoints: {
                769: {
                    centeredSlides: false,
                    centeredSlidesBounds: true,
            	    slidesPerView: 3,
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            slidesPerView: 'auto',
            spaceBetween: 20,
            speed: speed
	    });
    }

    const simpleCarousel = () => {
        let swiper = new Array(), status = false;

        const carousels = {
            destroy: function(el) {
                if (status === true) {
                    for (let i = 0; i < simple.length; i++) {
                        swiper[i].destroy();
                    }

                    status = false;
                }
            },

            start: function(el) {
                for (let i = 0; i < simple.length; i++) {
                    swiper[i] = new Swiper(simple[i], {
                        modules: [Navigation, Pagination],
                        breakpoints: {
                            511: {
                        	    spaceBetween: 20,
                        	    slidesPerGroup: 2,
                                slidesPerView: 2,
                            },
                        },
                        loop: true,
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true
                        },
                        slidesPerView: 'auto',
                        spaceBetween: 0,
                        speed: speed
            	    });
                }

                status = true;
            },

            toggle: function() {
                if (window.innerWidth <= 768) {
                    status === false ? carousels.start(simple) : false;
                } else {

                    carousels.destroy(simple);
                }
            }
        }

        carousels.toggle();
        window.addEventListener('resize', carousels.toggle);
    }
    const socialCarousel = () => {
        let swiper = new Array(), status = false;

        const carousels = {
            destroy: function(el) {
                if (status === true) {
                    for (let i = 0; i < social.length; i++) {
                        swiper[i].destroy();
                    }

                    status = false;
                }
            },

            start: function(el) {
                for (let i = 0; i < social.length; i++) {
                    swiper[i] = new Swiper(social[i], {
                        modules: [Navigation, Pagination],
                        breakpoints: {
                            511: {
                                slidesOffsetBefore: 0,
                        	    spaceBetween: 0,
                        	    slidesPerGroup: 2,
                                slidesPerView: 2,
                            },
                            768: {
                                slidesOffsetBefore: 0,
                        	    spaceBetween: 20,
                        	    slidesPerGroup: 3,
                                slidesPerView: 3,
                            },
                            1200: {
                                slidesOffsetBefore: 0,
                        	    spaceBetween: 20,
                        	    slidesPerGroup: 4,
                                slidesPerView: 4,
                            },
                        },
                        loop: true,
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true
                        },
                        slidesPerView: 'auto',
                        slidesOffsetBefore: 10,
                        spaceBetween: 0,
                        speed: speed
            	    });
                }

                status = true;
            },

            toggle: function() {
                if (window.innerWidth <= 1244) {
                    status === false ? carousels.start(social) : false;
                } else {

                    carousels.destroy(social);
                }
            }
        }

        carousels.toggle();
        window.addEventListener('resize', carousels.toggle);
    }

    window.carousels = function() {
        awards ? awardsCarousel() : false;
        cooperation ? cooperationCarousel() : false;
        delivers ? deliversCarousel() : false;
        hero ? heroCarousel() : false;
        document.querySelector('.js-productSmallCarousel') ? products_carousel() : false;
        mobile_carousel.length > 0 ? mobileCarousel() : false;
        ref ? refCarousel() : false;
        simple.length > 0 ? simpleCarousel() : false;
        social.length > 0 ? socialCarousel() : false;

       /*
 const swiper = new Swiper('.js-parent', {
            modules: [FreeMode],
            slidesPerView: 'auto',
            freeMode: {
                enabled: true,
                sticky: false,
                momentum: true,
                momentumBounce: true
            },
            speed: 800,
            on: {
                init: function () {
                    let year = document.querySelector('.years').querySelectorAll('li');

                    year[0].classList.add('is-active');
                },
            },
        });

        const thisIndex = function(elm) {
            let nodes = elm.parentNode.childNodes, node, i = 0, count = 0;

            while( (node = nodes.item(i++)) && node != elm ) {
                if( node.nodeType == 1 ) count++;
            }

            return count;
        };


        swiper.on('slideChange', function () {

            for (let i = 0; i < document.querySelector('.years').querySelectorAll('li').length; i++) {
                document.querySelector('.years').querySelectorAll('li')[i].classList.remove('is-active');
            }

            document.querySelector('.years').querySelectorAll('li')[swiper.realIndex].classList.add('is-active');
        });

        let year = document.querySelector('.years').querySelectorAll('li');

        for (let i = 0; year.length; i++) {
            year[i].addEventListener('click', function() {
                swiper.slideTo( thisIndex(year[i]) );
            })
        }
*/

    }

}, false)
